import Dexie from 'dexie';
import {getUsername} from '../../../_shared/GWTBridge/invoke/genPage';
import {
    PersonalizedMoreInfo,
    Entity,
    ScreenData
} from '../../../services/indexDB/indexeddbServiceZoomedScreens';

export const getMoreInfoEntity = async (
    db: PersonalizedMoreInfo,
    zoomFname: string,
    collectionDate: string
): Promise<Entity> => {
    const userName = getUsername();
    return db.screens.get({userName, zoomFname, collectionDate});
};

export const addNewMoreInfoEntity = async (
    db: PersonalizedMoreInfo,
    zoomFname: string,
    data: ScreenData,
    collectionDate: string
) => {
    try {
        db.screens.add({
            userName: getUsername(),
            zoomFname,
            collectionDate,
            screens: [{count: 1, form: data}]
        });
    } catch (err) {
        console.log('Error trying to add new MoreInfo screen ', err);
    }
};

export const updateMoreInfoEntity = async (
    db: PersonalizedMoreInfo,
    entity: Entity,
    data: ScreenData
) => {
    return db.screens
        .where('[userName+zoomFname+collectionDate]')
        .equals([entity.userName, entity.zoomFname, entity.collectionDate])
        .modify(ent => {
            const index = ent.screens.findIndex(screen => screen.form.entityId === data.entityId);
            if (index >= 0) {
                ent.screens[index].count = ent.screens[index].count + 1;
            } else {
                ent.screens.push({
                    count: 1,
                    form: data
                });
            }
        })
        .catch(Dexie.ModifyError, error => {
            console.log('Error modifying MoreInfo entity', error);
        });
};
